// extracted by mini-css-extract-plugin
var _1 = "FrK8v";
var _2 = "WGGkT";
var _3 = "YpjYT";
var _4 = "ApOBD";
var _5 = "lLwX3";
var _6 = "gOXGd";
export { _1 as "downloadPageLink", _2 as "downloadPageLinkIcon", _3 as "downloadsPageAlert", _4 as "downloadsPageContentWrapper", _5 as "downloadsPageHeader", _6 as "downloadsPageNoDownloads" }
